import React, { FC } from 'react';
import { Divider as ChakraDivider, Flex, Text } from '@chakra-ui/react';

interface Props {
  orientation?: 'vertical' | 'horizontal';
  variant?: 'sm' | 'md' | 'lg' | 'dashed' | 'borderDefault';
  size?: string;
  withText?: boolean;
  wrapText?: boolean;
  text?: string;
}

export const Divider: FC<Props> = ({
  orientation = 'horizontal',
  variant = 'sm',
  size = 'sm',
  withText = false,
  wrapText = false,
  text = '',
}) => {
  /**
   * DOM
   */
  const divider = (
    <ChakraDivider data-object-type="core-divider" orientation={orientation} variant={variant} size={size} />
  );
  if (withText && orientation === 'horizontal') {
    return (
      <Flex justify="center" padding="none" wrap={wrapText ? 'wrap' : 'inherit'} direction="row" align="center">
        {divider}
        <Text gap={'2xs'} paddingBottom={'xs'} textAlign="center" mx="2" my="0" textStyle="divider" flex="1 1 auto">
          {text}
        </Text>
        {divider}
      </Flex>
    );
  }
  return divider;
};
